import { SellerAdminChatContact, SellerAdminChatMessage, SellerAdminChatTimelineItem, SellerAdminChatVoiceCallItem } from "../types";

export function getInitials(name: string) {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join("") || "?"
  );
}

export function formatRelativeTime(iso?: string | null) {
  if (!iso) return "";
  const diffMin = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (diffMin < 1) return "agora";
  if (diffMin < 60) return `${diffMin} min`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH} h`;
  return new Date(iso).toLocaleDateString("pt-BR");
}

export function formatTime(iso: string) {
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatFileSize(bytes?: number | null) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function sortContacts(contacts: SellerAdminChatContact[]) {
  return [...contacts].sort((a, b) => {
    const unreadDiff = (b.unread_count || 0) - (a.unread_count || 0);
    if (unreadDiff !== 0) return unreadDiff;

    const timeA = a.last_message_at
      ? new Date(a.last_message_at).getTime()
      : 0;
    const timeB = b.last_message_at
      ? new Date(b.last_message_at).getTime()
      : 0;
    if (timeA !== timeB) return timeB - timeA;

    return String(a.name || "").localeCompare(String(b.name || ""), "pt-BR");
  });
}

export function filterContacts(
  contacts: SellerAdminChatContact[],
  query: string,
) {
  const q = query.trim().toLowerCase();
  if (!q) return contacts;

  return contacts.filter((contact) =>
    [contact.name, contact.subtitle, contact.preview]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(q),
  );
}

export function getMessageAttachments(message: SellerAdminChatMessage) {
  if (message.attachments?.length) return message.attachments;
  return message.attachment ? [message.attachment] : [];
}

export function getContactKey(contact: SellerAdminChatContact) {
  return `${contact.scope ?? "seller"}-${contact.id}`;
}

export function mergeChatTimeline(
  messages: SellerAdminChatMessage[] = [],
  voiceCalls: SellerAdminChatVoiceCallItem[] = [],
): SellerAdminChatTimelineItem[] {
  const messageItems = messages.map((message) => ({
    ...message,
    kind: "message" as const,
  }));

  return [...messageItems, ...voiceCalls].sort(
    (a, b) =>
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
  );
}
